/*
  HD hero slide descriptors (client, 2026-10-10 / 2026-10-11): every hero
  slider photo is cut from the full-resolution original at several widths
  (assets_raw/cut_heroes_hd.py for the landing, cut_ms_hd.py for the
  microsites + phones), encoded AVIF + WebP, and served as a <picture> with
  srcset + sizes=100vw so each screen downloads its own DPR-correct file.

  Shape (shared by Hero.jsx and MicroHero.jsx):
    { src, srcSet, sources: [{ type, srcSet }], hd: true, pos }
  `src` is the no-srcset fallback (the smallest WebP).
*/
const build = (dir, name, widths, pos) => ({
  src: `${dir}/${name}-${widths[0]}.webp`,
  sources: [{ type: "image/avif", srcSet: widths.map((w) => `${dir}/${name}-${w}.avif ${w}w`).join(", ") }],
  srcSet: widths.map((w) => `${dir}/${name}-${w}.webp ${w}w`).join(", "),
  hd: true,
  pos,
});

/** Desktop 16:10 microsite hero frame: /photos/hero-ms/<name>-{1920,2560,3840}. */
export const MS_HD = (name, widths = [1920, 2560, 3840], pos) => build("/photos/hero-ms", name, widths, pos);

/** Phone hero frame: /photos/mobile/hd/<name>-{1080,1620}. */
export const PHONE_HD = (name, widths = [1080, 1620], pos) => build("/photos/mobile/hd", name, widths, pos);

/** Client-delivered frame that only exists at web resolution: shipped untouched, never upscaled. */
export const NATIVE = (src, pos, sources = []) => ({ src, sources, srcSet: undefined, hd: true, pos });
